import Contact       from '@/domains/marketing/components/Contact';
import PrimaryLayout from '@/domains/marketing/layouts/PrimaryLayout';

export default function Home() {
	return (<PrimaryLayout pageTitle="Contact us">
		<Contact />
	</PrimaryLayout>);
}
